import { createFileRoute } from '@tanstack/react-router';
import { assertUuidRouteParams } from '../../../lib/assert-uuid-route-params.js';
import { RouteGuard } from '../../../lib/route-guard.js';
import { EventTemplateEditor } from '../../../modules/events/templates/event-template-editor.js';

export const Route = createFileRoute('/events/templates/$templateVersionId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: EditTemplatePage,
});

// eslint-disable-next-line react-refresh/only-export-components -- TanStack Router requires co-exporting Route with the component
function EditTemplatePage() {
  const { templateVersionId } = Route.useParams();
  return (
    <RouteGuard route="/events/templates">
      <EventTemplateEditor templateVersionId={templateVersionId} />
    </RouteGuard>
  );
}
